<div class="dialog-content">
  <div class="close-button">
    <img src="assets/cross.svg" alt="Cerrar" (click)="close()" />
  </div>
  <div class="dialog-title">
    <img src="assets/editar-borde.svg" alt="Editar" class="dialog-title-icon" />
    <div class="dialog-title-text">
      Solicitud Apelación
      <div class="dialog-title-subtitle">
        N° de Caso {{ data.caseNumber || "XXXX" }}
      </div>
    </div>
  </div>
  <div class="dialog-subtitle">REGISTRO DE APELACIONES</div>

  <div class="dialog-section-title">
    Concesionario
    <img src="assets/arrow-border.svg" alt="Flecha" />
    <hr />
  </div>

  <div class="concesionario-section">
    <div class="input-container">
      <div class="input-title required">NOMBRES</div>
      <input
        type="text"
        [(ngModel)]="nombres"
        (ngModelChange)="updateCanSubmit()"
        placeholder="Ingresar"
      />
    </div>

    <div class="input-container">
      <div class="input-title required">APELLIDOS</div>
      <input
        type="text"
        [(ngModel)]="apellidos"
        (ngModelChange)="updateCanSubmit()"
        placeholder="Ingresar"
      />
    </div>

    <div class="input-container">
      <div class="input-title required">EMAIL</div>
      <input
        type="text"
        [(ngModel)]="email"
        (ngModelChange)="updateCanSubmit()"
        placeholder="Ingresar"
      />
    </div>

    <div class="input-container">
      <div class="input-title required">TELÉFONO</div>
      <div class="telefono-input-wrapper">
        <span class="telefono-prefix">+569</span>
        <input
          type="text"
          class="telefono-input"
          [(ngModel)]="telefono"
          (ngModelChange)="updateCanSubmit()"
          maxlength="8"
          placeholder="Ingresar"
        />
      </div>
    </div>

    <div class="input-container">
      <div class="input-title required">OBSERVACIONES</div>
      <textarea
        [(ngModel)]="observaciones"
        (ngModelChange)="updateCanSubmit()"
        rows="5"
        placeholder="Ingrese aquí sus razones para apelar la solución del caso."
      ></textarea>
      <div class="char-count">{{ observaciones.length }}/<b>250</b></div>
    </div>

    <div class="dialog-subtitle">EVIDENCIA</div>

    @if (!selectedEvidenceFile) {
      <button
        class="adjuntar-evidencia-button"
        (click)="onAttachEvidenceClick(fileInput)"
      >
        <img src="assets/clip2.svg" alt="adjuntar" />
        <span>Adjuntar evidencia</span>
      </button>
      <div class="evidencia-info">
        Adjuntos Máx. <b>10MB</b> ({{ allowedEvidenceFormatsLabel }})
      </div>
    } @else {
      <div class="selected-file-name">
        <div class="selected-file-name--text">
          {{ selectedEvidenceName }}
        </div>
        <img
          src="assets/cerrar-chico.svg"
          alt="cerrar"
          (click)="removeFile()"
        />
      </div>
    }
    <input
      #fileInput
      type="file"
      [accept]="allowedEvidenceAccept"
      (change)="onEvidenceSelected($event)"
      style="display: none"
    />
    <hr />
  </div>

  <button class="action-button" (click)="reinsistir()" [disabled]="!canSubmit">
    Enviar Solicitud
  </button>
  <button class="red-button action-button" (click)="close()">Cancelar</button>
</div>

<lib-custom-alert
  [isVisible]="showAlert"
  [closeFunc]="closeAlert"
  [acceptFunc]="closeAlert"
  [hideGreyBackground]="hideGreyBackground"
  [showGreyBackground]="showGreyBackground"
  [scrollTo]="scrollTo"
  [icon]="alertIcon"
  [title]="alertTitle"
  [content]="alertContent"
>
</lib-custom-alert>
